<script setup lang="ts">

import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

import * as service from "@/services/empresaService";
import imgLogin from "@/assets/images/logoLogin.png";

const route = useRoute();
const router = useRouter();

var controle = reactive({
  empresaId: 0 as number | null,
  senha: "",
  nome: "",
  status: "" as string,
  erro: "" as string
})

onMounted(() => {

  controle.empresaId = route.query["empresaId"] ? Number(route.query["empresaId"]) : null
  controle.senha = route.query["senha"] ? String(route.query["senha"]) : ""

  if (controle.empresaId && controle.senha) {
    login();
  }

});

function login() {

  controle.status = "Realizando login...";

  service.loginExterno({ empresaId: controle.empresaId, senha: controle.senha })
    .then((response) => {

      if (response.accessToken) {
        localStorage.setItem('empresaUser', JSON.stringify(response));
        controle.nome = response.nome;
        controle.status = "Login realizado com sucesso! Redirecionando...";
        controle.erro = "";
      }

      setTimeout(() => {
        router.push({ name: "PainelEmpresa" });
      }, 2000);
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || error;
    });
}

</script>
<template>

  <div class="row">

    <div class="col-md-3"></div>

    <div class="col-md-6">

      <div class="row">
        <div class="col-md-12 text-center mb-5 mt-5">
          <img :src="imgLogin" alt="Login da Empresa" class="img-fluid">
        </div>

        <div class="col-md-12 text-center">
          <h2 class="mt-4 mb-3">Área da Empresa</h2>
        </div>

        <div class="col-md-12 text-center">
          <h3 class="mt-4 mb-3">Login automático</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mb-3">

          <div class="mt-3 text-primary text-center" v-if="controle.erro == ''">
            {{ controle.status }}
          </div>

          <div class="mt-3 text-success text-center" v-if="controle.nome != ''">
            Bem-vindo(a), {{ controle.nome }}!
          </div>

          <div class="mt-3 text-danger text-center" v-if="controle.erro != ''">
            {{ controle.erro }}
          </div>
        </div>
      </div>

      <div class="col-md-3"></div>
    </div>
  </div>
</template>
